<template>
  <div>
    <button v-if="loading" :class="[type, size]" class="button" @click="clickHandler" disabled>
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </button>
    <button v-else :class="[type, size]" class="button" @click="clickHandler">
      {{label}}
    </button>
  </div>
</template>

<script>

export default {
  name: 'Button',

  props: [
    'loading',
    'label',
    'type',
    'size',
  ],

  methods: {
    clickHandler(e) {
      if (this.disabled) {
        return
      }
      this.$emit('click', e)
    }
  }
}

</script>

<style scoped>
.button {
  border-radius: 5px;
  text-align: center;
  border: none;
  min-width: 80px;
}

.normal {
  padding: 10px 20px;
  font-size: 14px;
}

.long {
  padding: 10px 20px;
  font-size: 14px;
  width: 90%;
  margin: 0 auto;
}

.primary {
  background: #f3983b;
  color: #fff;
}

.disabled {
  background: #909090;
  color: #fff;
}

.white {
  background: #fff;
  color: #f3983b;
  border: 1px solid #BFBFBF;
}

.cancel {
  border: 1px solid #BFBFBF;
  background: #fff;
}

.fa-circle-o-notch {
  color: #fff;
  font-size: 23px;
}
</style>
